export const CONTENT_TYPES = {
    BLOG: 1,
    FILE: 2,
    LINK: 3,
    PATHWAY: 4,
    FEATURED: 5,
    ORGANIZATION: 6,
    FITNESS: 7,
};